import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

var AuthContext = createContext();

var API_URL = process.env.REACT_APP_BACKEND_URL;

// Send cookies on every request (httpOnly JWT auth)
axios.defaults.withCredentials = true;

// Global 401 handler: try to refresh the access token once, then retry the request.
axios.interceptors.response.use(
  function (response) { return response; },
  function (error) {
    var original = error.config;
    var isAuthCall = original && original.url && original.url.indexOf('/api/auth/') >= 0;
    if (error.response && error.response.status === 401 && original && !original._retry && !isAuthCall) {
      original._retry = true;
      return axios.post(API_URL + '/api/auth/refresh', {}, { withCredentials: true })
        .then(function () {
          original.withCredentials = true;
          return axios(original);
        })
        .catch(function () { return Promise.reject(error); });
    }
    return Promise.reject(error);
  }
);

export function useAuth() {
  var context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}

export function AuthProvider(props) {
  var children = props.children;
  var userState = useState(null);
  var user = userState[0];
  var setUser = userState[1];
  
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];

  useEffect(function() {
    checkAuth();
  }, []);

  function checkAuth() {
    axios.get(API_URL + '/api/auth/me', { withCredentials: true })
      .then(function(response) {
        setUser(response.data);
        setLoading(false);
      })
      .catch(function(error) {
        // Try to refresh token if access token expired
        if (error.response && error.response.status === 401) {
          axios.post(API_URL + '/api/auth/refresh', {}, { withCredentials: true })
            .then(function() {
              // Retry getting user after refresh
              return axios.get(API_URL + '/api/auth/me', { withCredentials: true });
            })
            .then(function(response) {
              setUser(response.data);
              setLoading(false);
            })
            .catch(function() {
              setUser(null);
              setLoading(false);
            });
        } else {
          setUser(null);
          setLoading(false);
        }
      });
  }

  function login() {
    // Redirect to login page
    window.location.href = '/login';
  }

  function logout() {
    axios.post(API_URL + '/api/auth/logout', {}, { withCredentials: true })
      .then(function() {
        setUser(null);
        window.location.href = '/';
      })
      .catch(function(error) {
        console.error('Logout error:', error);
        setUser(null);
        window.location.href = '/';
      });
  }

  var value = {
    user: user,
    loading: loading,
    login: login,
    logout: logout,
    setUser: setUser,
    checkAuth: checkAuth,
    isAuthenticated: !!user
  };

  return React.createElement(AuthContext.Provider, { value: value }, children);
}
